const fallbackProtocol =
  typeof window !== "undefined" ? window.location.protocol : "http:";
const fallbackHost =
  typeof window !== "undefined" ? window.location.hostname : "localhost";

const configuredApiBase = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

function shouldUseDevProxy() {
  if (process.env.NODE_ENV !== "development") {
    return false;
  }

  if (!configuredApiBase) {
    return true;
  }

  try {
    const parsed = new URL(configuredApiBase);
    return ["localhost", "127.0.0.1", "::1"].includes(parsed.hostname);
  } catch {
    return false;
  }
}

const API_BASE = shouldUseDevProxy()
  ? ""
  : (configuredApiBase || `${fallbackProtocol}//${fallbackHost}:2350`).replace(/\/$/, "");

/**
 * Fetch wrapper kept for consistent API usage across the app.
 */
export const appwriteFetch = (url, options = {}) => {
  return fetch(url, options);
};

export default API_BASE;
